// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"252":"22c3b988","770":"c3bb8c46","812":"3045b40c"}[chunkId] + ".js";
};